import { useForm } from "react-hook-form";
import EndPoints from "src/Constants/EndPoints";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import SnackbarHandler from "src/Utils/SnackbarHandler";
import { useTranslation } from "react-i18next";
import { locale } from "moment";

type Inputs = {
  fname: string,
  lname: string,
  email: string,
  question: string,
};

function ContactUsEn({ locale } : { locale? : string}) {
  const { t : translate , i18n } = useTranslation();
  const t = (word : string) => translate(word , {lng : locale ?? i18n.language}) 
  const { register, handleSubmit, errors, setValue } = useForm<Inputs>();
  const dir = !locale ? i18n.dir() : locale === "ar" ? "rtl" : "ltr";

  const [contactUs, { status }] = useApiMutation({
    onSuccess: () => {
      setValue("fname", "");
      setValue("lname", "");
      setValue("email", "");
      setValue("question", "");
      SnackbarHandler.successToast(
        t("Thank you for contacting us. We will get back to you within 24 hours")
      );
    },
    onError: () => {
      SnackbarHandler.contactErrorToast("Something went wrong")
    }
  });
  const onSubmit = async (params: any) => {
    if (status === "loading") {
      return;
    }
    try {
      await contactUs({
        url: EndPoints.contactUs,
        data: params
      });
    } catch (error) {
      console.log(error)
    }
  };

  return (
    <section className="terms_condition_section" dir={dir} >
      <div className="container">
        <div className="row">
          <div className="col-12">
          <div className={`col_selector ${dir === "rtl" ? "text-right" : "text-left"}`}>
              <h2 >{t('Contact Us')}</h2>
              <div className="login_section">
                <div className="row">
                  <div className="col-6">
                    <div className="contact">
                      <p><span className="mr-2"><i className="fa fa-envelope"></i></span> <a href="mailto:support@houmti.dz">support@houmti.dz</a></p>
                    </div>
                    <form className="" onSubmit={handleSubmit(onSubmit)}>
                      <div className="form-group">
                        <input type="text" name="fname" className="form-control" placeholder={t("First Name")} ref={register({ required: t("FirstName is required")+"" })} />
                        {errors.fname && <span className="ml-3 text-danger">{errors.fname.message}</span>}
                      </div>
                      <div className="form-group">
                        <input type="text" name="lname" className="form-control" placeholder={t("Last Name")} ref={register({ required: t("LastName is required")+"" })} />
                        {errors.lname && <span className="ml-3 text-danger">{errors.lname.message}</span>}
                      </div>
                      <div className="form-group">
                        <input type="text" name="email" className="form-control" placeholder={t("Email")} ref={register({
                          required: t("Email is required")+"",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: t("Email Address is invalid")+""
                          }
                        })} />
                        {errors.email && <span className="ml-3 text-danger">{errors.email.message}</span>}
                      </div>
                      <div className="form-group">
                        <textarea name="question" cols={30} rows={8} style={{ height: '150px' }} className="form-control" placeholder={t("Your Question?")} ref={register({ required: t("What is your query?")+"" })}></textarea>
                        {errors.question && <span className="ml-3 text-danger">{errors.question.message}</span>}
                      </div>
                      <div className="form-group">
                        <button className="btn custom_btn w-100" type="submit">{t('Send')}</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div >
    </section >
  )
}
export default ContactUsEn;
